import { gql } from '@apollo/client';

export const getFeatureFlagsQuery = gql`
    query GetFeatureFlags {
        user {
            id
            featureFlags {
                rituals
                journal
                ratings
                rewards
                goals
            }
        }
    }
`;
